/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrSubscriptionModesEnum = 'UNKNOWN' | 'TRIAL' | 'SUBSCRIPTION' | 'RWR_ONLY_TRIAL' | 'RWR_ONLY_SUBSCRIPTION' | 'DR_RWR_TRIAL' | 'DR_RWR_SUBSCRIPTION' | 'DR_RWR_LIMITED_TRIAL' | 'DR_RWR_LIMITED_SUBSCRIPTION';

export const IrrSubscriptionModesEnum = {

    UNKNOWN: 'UNKNOWN' as IrrSubscriptionModesEnum,

    TRIAL: 'TRIAL' as IrrSubscriptionModesEnum,

    SUBSCRIPTION: 'SUBSCRIPTION' as IrrSubscriptionModesEnum,

    RWR_ONLY_TRIAL: 'RWR_ONLY_TRIAL' as IrrSubscriptionModesEnum,

    RWR_ONLY_SUBSCRIPTION: 'RWR_ONLY_SUBSCRIPTION' as IrrSubscriptionModesEnum,

    DR_RWR_TRIAL: 'DR_RWR_TRIAL' as IrrSubscriptionModesEnum,

    DR_RWR_SUBSCRIPTION: 'DR_RWR_SUBSCRIPTION' as IrrSubscriptionModesEnum,

    DR_RWR_LIMITED_TRIAL: 'DR_RWR_LIMITED_TRIAL' as IrrSubscriptionModesEnum,

    DR_RWR_LIMITED_SUBSCRIPTION: 'DR_RWR_LIMITED_SUBSCRIPTION' as IrrSubscriptionModesEnum
};

